export default {
  colors: {
    "bg-canvas": {
      default: "blueGray.50",
      _dark: "blueGray.900",
    },
    "bg-surface": {
      default: "white",
      _dark: "blueGray.800",
    },
    "bg-subtle": {
      default: "blueGray.50",
      _dark: "blueGray.700",
    },
    "bg-muted": {
      default: "blueGray.100",
      _dark: "blueGray.600",
    },

    default: {
      default: "blueGray.900",
      _dark: "white",
    },
    inverted: {
      default: "white",
      _dark: "blueGray.900",
    },
    emphasized: {
      default: "blueGray.700",
      _dark: "blueGray.100",
    },
    muted: {
      default: "blueGray.600",
      _dark: "blueGray.300",
    },
    subtle: {
      default: "blueGray.500",
      _dark: "blueGray.400",
    },
    border: {
      default: "blueGray.200",
      _dark: "#333e51", // lighten('blueGray.700', 3)(props.theme)
    },
    accent: {
      default: "brand.600",
      _dark: "brand.200",
    },
    success: {
      default: "green.600",
      _dark: "green.200",
    },
    error: {
      default: "red.600",
      _dark: "red.200",
    },
    "bg-accent": "brand.600",
    "bg-accent-subtle": "brand.500",
    "bg-accent-muted": "brand.400",
    "on-accent": "white",
    "on-accent-muted": "brand.50",
    "on-accent-subtle": "brand.100",
   
  },
};
